<div class="version">{{ver}}</div>
<router-outlet></router-outlet>
<div class="loader-overlay" *ngIf="isLoading">
  <div class="spinner-background">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">{{loaderText}}</span>
    </div>
    <span class="spinner-message">{{loaderText}}</span>
  </div>
</div>
